import { render, staticRenderFns } from "./QStatsPlacedChart.vue?vue&type=template&id=f01cef0a&"
import script from "./QStatsPlacedChart.vue?vue&type=script&lang=js&"
export * from "./QStatsPlacedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports